import { Page } from '@/components/page';
import { StripeCheckout } from '@/components/stripe-checkout';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { useEffect, useState } from 'react';
import { usePlanCreate } from '@/hooks/plans/use-plan-create';
import { useParams } from 'react-router-dom';
import { usePlanCreatePaymentIntent } from '@/hooks/plans/use-plan-payment-intent';
import { useStripeProduct } from '@/hooks/use-stripe-product';
import { LoadingScreenSpinner } from '@/components/loading-screen-spinner';

const stripePromise = import.meta.env.VITE_STRIPE_PUBLIC_KEY
  ? loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY)
  : null;

interface Plan {
  id: string;
  amount: number;
  product: {
    description: string;
    name: string;
  };
}

export function PurchasePlan() {
  const { priceId } = useParams();
  const [clientSecret, setClientSecret] = useState<string>();
  const [checkoutPlan, setCheckoutPlan] = useState<Plan>();
  const [customerId, setCustomerId] = useState<string>();
  const createPlan = usePlanCreate();
  const createPaymentIntent = usePlanCreatePaymentIntent();
  const [formattedPriceId, setFormattedPriceId] = useState<string>();
  const { data: stripeProduct } = useStripeProduct({priceId: formattedPriceId });


  useEffect(() => {
    const asyncCreatePlan = async () => {
      if (!priceId) {
        return;
      }

      setFormattedPriceId('price_' + priceId);

      const response = await createPaymentIntent.mutateAsync();

      setClientSecret(response.clientSecret);
  
      // const response = await createPlan.mutateAsync({
      //   priceId: 'price_' + priceId
      // });

      // setClientSecret(response.clientSecret);
      // setCheckoutPlan(response.plan);
      // setCustomerId(response.customerId);
      // console.log('customerId', response);
    }

    asyncCreatePlan();
  }, []);

  useEffect(() => {
    const plan = {
      id: stripeProduct?.id,
      amount: stripeProduct?.price?.unit_amount ? stripeProduct?.price?.unit_amount : 0,
      priceId: formattedPriceId || '',
      product: {
        description: stripeProduct?.description || '',
        name: stripeProduct?.name || ''
      }
    };

    setCheckoutPlan(plan);
  }, [stripeProduct]);

  if (!clientSecret) {
    return (
      <div className="flex items-center justify-center h-screen mt-[-64px]">
        <div className="flex-1">
          <LoadingScreenSpinner />
        </div>
      </div>
    )
  }

  const options = {
    clientSecret: clientSecret,
    appearance: {
      /*...*/
    },
  };

  return (
    <Page title="Purchase Plan">
      <Elements stripe={stripePromise} options={options}>
        {checkoutPlan && <StripeCheckout plan={checkoutPlan} />}
      </Elements>
    </Page>
  );
}
